<template>
  <div class="page_box" :style="styleObj.page">
    <el-button class="goBack" type="danger" size="small" @click="diaClose()">返回</el-button>

    <div class="head_box" :style="styleObj.head">
      <OneHead tit="数据可视化智能应用平台" style="height: 100%; width: 100%;" />
      <component v-for="(item, index) in layoutCompontent['head']" :key="index" :is="item.tag"></component>
    </div>
    <div class="main_content">
      <div class="left_box" :style="styleObj.left">
        <div
          v-for="(item, index) in layoutCompontent['left']"
          :key="index"
          :style="{ height: item.height, width: item.width, display: 'inline-block' }"
          @click="selCompontent('left', index)"
          :class="{ sel_box: activeId.position === 'left' && activeId.index === index }"
        >
          <component
            :width="item.width"
            :height="item.height"
            :is="item.tag"
            :tit="item.tit"
            :color="item.color"
            :color2="item.color2"
          ></component>
        </div>

        <!-- <RingChartModule :style="{ width: '100%', height: '30%', display: 'inline-block' }" /> -->
      </div>
      <div class="center_box" :style="styleObj.center">
        <div
          v-for="(item, index) in layoutCompontent['center']"
          :key="index"
          :style="{ height: item.height, width: item.width, display: 'inline-block' }"
          @click="selCompontent('center', index)"
          :class="{ sel_box: activeId.position === 'center' && activeId.index === index }"
        >
          <component :is="item.tag"></component>
        </div>
      </div>
      <div class="right_box" :style="styleObj.right">
        <div
          v-for="(item, index) in layoutCompontent['right']"
          :key="index"
          :style="{ height: item.height, width: item.width, display: 'inline-block' }"
          @click="selCompontent('right', index)"
          :class="{ sel_box: activeId.position === 'right' && activeId.index === index }"
        >
          <component :is="item.tag" :tit="item.tit" :color="item.color" :color2="item.color2"></component>
        </div>
      </div>
    </div>

    <div class="btn_box" v-show="!diaShow">
      <el-button size="samll" type="primary" icon="el-icon-setting" circle @click="diaShow = true"></el-button>
    </div>

    <panel v-show="diaShow" :styleObj="styleObj" :activeData="activeData" :dataSourceObj="dataSourceObj" />

    <div v-show="diaShow" class="operation_box">
      <el-button class="close_btn" icon="el-icon-close" type="danger" plain circle @click="diaShow = false"></el-button>
      <p>大屏信息</p>
      <el-form :model="dataBoardInfo" ref="dataBoardInfo" :inline="true" label-width="90px">
        <el-form-item label="大屏名称：" prop="">
          <div class="input_box">
            <el-input v-model="dataBoardInfo.name" placeholder="" size="normal" clearable></el-input>
          </div>
        </el-form-item>
      </el-form>
      <el-button @click="show = true">修改页面配置</el-button>
      <el-button type="primary" @click="onSave()">保存</el-button>
    </div>

    <el-dialog title="添加组件" :visible.sync="show" width="40%" @close="show = false" append-to-body>
      <el-form :model="infoData" ref="infoData" :inline="true" label-width="90px">
        <el-form-item label="布局:" prop="">
          <div class="input_box">
            <el-select v-model="infoData.layout" placeholder="" clearable filterable @change="setLayout()">
              <!-- <el-option label="head_box" value="head"> </el-option> -->
              <el-option label="left_box" value="left"> </el-option>
              <el-option label="center_box" value="center"> </el-option>
              <el-option label="right_box" value="right"> </el-option>
            </el-select>
          </div>
        </el-form-item>
        <el-form-item label="组件：" prop="">
          <div class="input_box">
            <el-select v-model="infoData.sel" placeholder="" clearable filterable>
              <el-option v-for="item in components" :key="item.tag" :label="item.label" :value="item.tag"> </el-option>
            </el-select>
          </div>
          <el-button style="margin-left: 10px;" type="primary" @click="addItem()">添加组件</el-button>
        </el-form-item>

        <el-table :data="infoData.componentList" style="width: 100%" row-key="dbFieldName" class="table_box drow_table">
          <el-table-column
            v-for="(col, i) in tableHeader"
            :prop="col.prop"
            :key="i"
            :label="col.label"
            :width="col.width || ''"
            :align="col.align || 'center'"
          >
            <template slot="header">
              <p>
                {{ col.label }}
                <span style="color:red;font-size:16px;">*</span>
              </p>
            </template>

            <template slot-scope="scope">
              <el-form-item :prop="'componentList.' + scope.$index + '.name'">
                <ex-slot v-if="col.render" :render="col.render" :row="scope.row" :index="scope.$index" :column="col"> </ex-slot>
                <span v-else>{{ scope.row[col.prop] || "-" }}</span>
              </el-form-item>
            </template>
          </el-table-column>

          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <el-tooltip class="item" effect="dark" content="删除" placement="bottom">
                <el-button type="danger" plain icon="el-icon-delete" circle @click="deleteItem(scope.$index)"></el-button>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
      </el-form>

      <span slot="footer">
        <el-button @click="show = false">取 消</el-button>
        <el-button type="primary" @click="show = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// 自定义内容的组件
var exSlot = {
  functional: true,
  props: {
    row: Object,
    render: Function,
    index: Number,
    column: {
      type: Object,
      default: null
    }
  },
  render: (h, data) => {
    const params = {
      row: data.props.row,
      index: data.props.index
    };
    if (data.props.column) params.column = data.props.column;
    return data.props.render(h, params);
  }
};
import Sortable from "sortablejs";
export default {
  components: {
    //自定义组件
    "ex-slot": exSlot,
    panel: () => import("./compontent/panel.vue"),
    OneHead: () => import("../../components/Theme/one/head.vue"),
    OneTit: () => import("../../components/Theme/one/tit.vue"),
    OneLineChart: () => import("../../components/Theme/one/dashboard/LineChart.vue"),
    OneBarChart: () => import("../../components/Theme/one/dashboard/BarChart.vue"),
    OneRingChart: () => import("../../components/Theme/one/dashboard/RingChart.vue"),
    OneWaterGlobeChart: () => import("../../components/Theme/one/dashboard/WaterGlobeChart.vue"),
    OneProChart: () => import("../../components/Theme/one/dashboard/proChart.vue"),
    ScrollList: () => import("../../components/Theme/one/ScrollList.vue"),
    OneCenterBox: () => import("../../components/Theme/one/center.vue")

    // RingChartModule: () => import("../../components/Theme/one/RingChartModule.vue"),
    // WaterGlobeChartModule: () => import("../../components/Theme/one/WaterGlobeChartModule.vue")
  },
  props: {
    row: Object
  },
  data() {
    return {
      dataBoardInfo: {
        id: null,
        name: "",
        config: "",
        modelId: 0
      },
      show: false,
      infoData: {
        layout: "",
        sel: "",
        componentList: []
      },

      // 大屏可配置的 子组件
      components: [
        {
          label: "大屏1 - 模块标题",
          tag: "OneTit"
        },
        {
          label: "大屏1 - 线形图",
          tag: "OneLineChart"
        },
        {
          label: "大屏1 - 柱形图",
          tag: "OneBarChart"
        },
        {
          label: "大屏1 - 环形图",
          tag: "OneRingChart"
        },
        {
          label: "大屏1 - 水球图",
          tag: "OneWaterGlobeChart"
        },
        {
          label: "大屏1 - 横向柱形图",
          tag: "OneProChart"
        },
        {
          label: "大屏1 - 滚动列表",
          tag: "ScrollList"
        },
        {
          label: "大屏1 - 中间组件",
          tag: "OneCenterBox"
        }
        // {
        //   label: "大屏1 - 环形图模块",
        //   tag: "RingChartModule"
        // },
        // {
        //   label: "大屏1 - 水球图模块",
        //   tag: "WaterGlobeChartModule"
        // }
      ],

      // 布局样式
      styleObj: {
        page: {
          width: "100%",
          height: "100%",
          "background-img": "url('../../assets/theme/one/bg.png')"
          // "background-color": "",
          // "text-align": "center"
        },
        head: {
          width: "100%",
          height: "84px"
          // "background-img": "",
          // "background-color": "",
          // "text-align": "center"
        },
        left: {
          width: "25%",
          height: "100%"
          // "background-color": "pink"
        },
        center: {
          width: "50%",
          height: "100%"
          // "background-color": "red"
        },
        right: {
          width: "25%",
          height: "100%"
          // "background-color": "pink"
        }
      },
      dataSourceObj: {},
      // 数据源
      dataSourceArr: [
        {
          label: "数据源类型",
          value: "type"
        },
        {
          label: "数据源",
          value: "type"
        }
      ],
      layoutCompontent: {
        head: [],
        left: [],
        center: [],
        right: []
      },

      activeId: {
        position: null,
        index: null
      },
      activeData: {},

      tableHeader: [
        {
          label: "组件名称",
          prop: "label"
        },
        {
          label: "组件",
          prop: "tag"
        }
      ],

      diaShow: false
    };
  },
  created() {
    if (this.row.id) {
      this.dataBoardInfo.id = this.row.id;
      this.getToolBiInfo();
    }
  },

  mounted() {
    // let obj = JSON.parse(sessionStorage.getItem("layoutCompontent"));
    // if (obj) this.layoutCompontent = obj;
    // this.activeData = this.layoutCompontent["left"][0];
  },
  methods: {
    async getToolBiInfo() {
      const { data } = await this.$api.getToolBiInfo({
        id: this.dataBoardInfo.id
      });
      console.log("data", data);
      Object.keys(this.dataBoardInfo).forEach(key => {
        this.dataBoardInfo[key] = data[key];
      });
      let obj = JSON.parse(this.dataBoardInfo.config);
      if (obj) this.layoutCompontent = obj;
      this.activeData = this.layoutCompontent["left"][0];
    },
    onSave() {
      console.log("layoutCompontent", this.layoutCompontent);
      sessionStorage.setItem("layoutCompontent", JSON.stringify(this.layoutCompontent));
      // sessionStorage.setItem("layoutCompontent", this.layoutCompontent);
      this.dataBoardInfo.config = JSON.stringify(this.layoutCompontent);
      if (this.dataBoardInfo.id) {
        this.$emit("onUpdate", this.dataBoardInfo);
      } else {
        this.$emit("onAdd", this.dataBoardInfo);
      }
    },
    diaClose() {
      this.$emit("diaClose");
    },
    //行拖拽
    rowDrop() {
      const tbody = document.querySelector(".drow_table  .el-table__body-wrapper tbody");
      // console.log("tbody", tbody);
      const _this = this;
      Sortable.create(tbody, {
        onEnd({ newIndex, oldIndex }) {
          console.log("newIndex, oldIndex", newIndex, oldIndex);
          let currRow = _this.infoData.componentList.splice(oldIndex, 1)[0];
          console.log("currRow", currRow);
          _this.infoData.componentList.splice(newIndex, 0, currRow);
          // console.log("_this.infoData.componentList", _this.infoData.componentList);
          _this.onSort(_this.infoData.componentList);
        }
      });
    },
    setLayout() {
      this.infoData.componentList = this.layoutCompontent[this.infoData.layout];
    },
    // par:  对比值、唯一值(一般为id)  arr: 数组  key: par 对应的 key（属性的key） findPar：需要查找的参数
    getPar(par, arr, key, findPar) {
      const getValueByPar = par => arr => arr.find(item => item[key] === par)[findPar];
      return getValueByPar(par)(arr);
    },

    addItem() {
      if (!this.infoData.sel || !this.infoData.layout) return;
      let obj = {};

      switch (this.infoData.sel) {
        case "OneTit":
          obj = {
            tag: this.infoData.sel,
            label: this.getPar(this.infoData.sel, this.components, "tag", "label"),
            width: "100%",
            height: "45px",
            tit: ""
          };
          break;
        default:
          this.dataBoardInfo.modelId++;
          obj = {
            id: this.dataBoardInfo.modelId,
            tag: this.infoData.sel,
            label: this.getPar(this.infoData.sel, this.components, "tag", "label"),
            width: "100%",
            height: "30%",
            color: "",
            color2: "",
            type: null,
            viewId: null
          };
          break;
      }
      this.infoData.componentList.push(obj);
    },
    deleteItem(i) {
      this.infoData.componentList.splice(i, 1);
    },

    selCompontent(position, index) {
      this.activeId = { position, index };
      this.activeData = this.layoutCompontent[position][index];
    }
  }
};
</script>

<style lang="scss" scoped>
.page_box {
  width: 100%;
  height: 100%;
  background-image: url("../../assets/theme/one/bg.png");
  // background-image: url("../../assets/theme/one/center.png");
  background-repeat: no-repeat;
  background-size: 100%;
  // display: flex;
  // flex-direction: column;

  .head_box {
    width: 100%;
  }

  .main_content {
    width: 100%;
    // height: calc(100% - 84px);
    height: calc(100% - 100px);
    // height: 100%;
    // flex: 1;
  }

  .left_box,
  .center_box,
  .right_box {
    display: inline-block;
    vertical-align: top;
  }
}

.operation_box {
  position: fixed;
  right: 0;
  top: 0;
  width: 350px;
  height: 200px;
  z-index: 100;
  // background-color: pink;
  text-align: center;
  background-color: #fff;

  .close_btn {
    position: absolute;
    right: 10px;
    top: 10px;
  }
}

.btn_box {
  position: fixed;
  right: 0;
  top: 30%;
  width: 60px;
  height: 60px;
  line-height: 60px;
  border-radius: 3px;
  z-index: 100;
  text-align: center;
  background-color: #fff;
}

.input_box {
  display: inline-block;
}

.sel_box {
  border: 2px solid aquamarine;
  box-sizing: border-box;
}
.goBack {
  position: absolute;
  left: 10px;
  top: 10px;
  width: 80px;
  z-index: 100;
}
</style>
